import { useDispatch, useSelector } from 'react-redux';
import { WidgetID } from '../../../models/widget.model';
import { RootState } from '../../../store';
import { selectWidgetSort, setWidgetSort } from '../../../store/slices/widget-sort.slice';
import { useCallback } from 'react';
import { GridSortChangeEvent, isColumnMenuSortActive } from '@progress/kendo-react-grid';
import { SortDescriptor, State } from '@progress/kendo-data-query';
import { ColumnModel } from 'common/models/widget-config.model';

export function useGridWithSort(
  id: WidgetID,
  columns: ColumnModel[],
  useColumnIdsForSort?: boolean
) {
  const dispatch = useDispatch();
  const sort = useSelector((state: RootState) => selectWidgetSort(state, id));
  const isColumnSorted = (field: string, dataState: State): boolean => {
    return isColumnMenuSortActive(field, dataState.sort);
  };
  const transformedSort = useColumnIdsForSort
    ? sort.map((value) => {
        const targetColumn = columns.find((col) => col.id === value.field);
        return {
          ...value,
          field: targetColumn ? targetColumn.field : value.field,
        } as SortDescriptor;
      })
    : sort;
  const onSortChange = useCallback(
    (e: GridSortChangeEvent) => {
      let sortData = e.sort;
      if (useColumnIdsForSort) {
        sortData = sortData.map((value) => {
          const targetColumn = columns.find((col) => col.field === value.field);
          return {
            ...value,
            field: targetColumn ? targetColumn.id : value.field,
          } as SortDescriptor;
        });
      }
      dispatch(
        setWidgetSort({
          id: id,
          sort: sortData,
        })
      );
    },
    [dispatch, id, columns, useColumnIdsForSort]
  );

  return { sort: useColumnIdsForSort ? transformedSort : sort, onSortChange, isColumnSorted };
}
